export interface SourceOfWealth {
  type: SourceOfWealthType;
  frequency: SourceOfWealthFrequency;
  description?: string; //required for SourceType "Other"
  isUsedForFunds: boolean;
}

export const sourceOfWealthTypes = [
  "allowance",
  "disability",
  "income",
  "inheritance",
  "interest",
  "marketProfit",
  "pension",
  "property",
  "other",
] as const;
export type SourceOfWealthType = typeof sourceOfWealthTypes[number];

export const sourceOfWealthFrequencies = ["annual", "oneTime", "periodic"] as const;
export type SourceOfWealthFrequency = typeof sourceOfWealthFrequencies[number];
